// 监控大屏
import request from '@/utils/util.js'

// 获取大屏的数据
export function getMonitorAPI(data) {
	return request.get('/monitor', data)
}

// 获取派车大屏的数据
export function getDispatchMonitorAPI() {
	return request.get('/car_monitor')
}

// 呼救相应
export function alarmResponseAPI(data) {
	return request.post('/alarm/response', data)
}
